// Libraries
import { Button, Flex } from '@chakra-ui/react';
import NextLink from 'next/link';
// Types
import { NavLinkTabsProps } from './NavLinkTabs.type';

/**
 * Represents a navigation link tabs component.
 *
 * @component
 * @param {NavLinkTabsProps} props - The props for the NavLinkTabs component.
 * @param {Array<LinkTab>} props.tabs - An array of tab objects with their unique IDs, hrefs, and labels.
 * @param {string} props.active - The ID of the active tab.
= * @returns {ReactElement} The rendered NavLinkTabs component.
 */
export const NavLinkTabs = ({ tabs, active }: NavLinkTabsProps) => {
  return (
    <Flex as='ul' data-testid='nav-link-tabs' listStyleType='none' gap={4} h={6}>
      {tabs.map((item) => {
        const visibility = active == item.id ? 'visible' : 'hidden';
        const dataSelected = active == item.id ? '' : undefined;
        return (
          <Flex
            as='li'
            key={item.id}
            justify='space-between'
            direction='column'
            _after={{
              visibility,
              content: '""',
              backgroundColor: 'base',
              display: 'block',
              height: '3px',
              width: 'full',
              borderRadius: 'md',
            }}
          >
            <NextLink href={item.href} passHref legacyBehavior>
              <Button as='a' variant='tab' data-selected={dataSelected}>
                {item.label}
              </Button>
            </NextLink>
          </Flex>
        );
      })}
    </Flex>
  );
};
